import notificationTemplate from './template';

const CLASS_NAME = {
  CLOSED: 'notification--closed'
};

const SELECTOR = {
  NOTIFICATION_CLOSE_BUTTON: '.btn'
};

export const DEFAULT_SELECTOR = '.notification';

class Notification {
  static render(type, message) {
    let notificationElementTemplate = document.createElement('template');

    notificationElementTemplate.innerHTML = notificationTemplate({
      type: 'error',
      message: message
    });

    const notificationElement = notificationElementTemplate.content.children[0];

    document.body.appendChild(notificationElement);

    new Notification(notificationElement);
  }

  /**
   * Initializer
   *
   * @param {Element} elementRef - the notification target element.
   * */
  constructor(elementRef) {
    this.notification = elementRef;
    this.notificationCloseButton = this.notification.querySelector(SELECTOR['NOTIFICATION_CLOSE_BUTTON']);

    this.onCloseNotification = this.onCloseNotification.bind(this);

    this._addEventListeners();
  }

  // Event Handlers

  /**
   * Event handler for close notification.
   * */
  onCloseNotification() {
    this.notification.classList.add(CLASS_NAME['CLOSED']);
  }

  // private

  /**
   * Adds all the required event listeners.
   * */
  _addEventListeners() {
    this.notificationCloseButton.addEventListener('click', this.onCloseNotification);
  }
}

export default Notification;
